import { render } from "./GoodsListItem.vue?vue&type=template&id=d8021fc8&scoped=true"
import script from "./GoodsListItem.vue?vue&type=script&lang=js"
export * from "./GoodsListItem.vue?vue&type=script&lang=js"

import "./GoodsListItem.vue?vue&type=style&index=0&id=d8021fc8&scoped=true&lang=scss"

import exportComponent from "D:\\projects\\APP\\vue3-ewshop\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8021fc8"]])

export default __exports__